export default "__VITE_ASSET__fd9ba155__"